export default "__VITE_ASSET__DiMjP8nU__ 800w";